export default __webpack_public_path__ + "static/media/µ¡úÚØó.d0520279.jpg";